<!--======= Banner Form Start Here ========-->
<div class="overflow">
  <div id="main-wrapper">
    <div class="site-wrapper-reveal">
      <div class="position-relative w-100">
        <div class="d-flex align-items-center h-100 w-100">
          <img src="../../../assets/images/InternshipPage/InternshipBanner.png" alt="Internship banner"
            class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" />
          <img src="../../../assets/images/InternshipPage/InternshipMobileBanner.png"
            class="img img-responsive d-block d-md-none" width="100%" alt="mobile Internship banner" />
          <div class="position-absolute w-100 home-banner">
            <div class="row h-100 w-100">
              <div class="col-12 col-md-7 col-lg-6  banner-section pt-3">
                <div class="align-items-center banner-content-title  global_title global_banner_title" aria-level="1"
                  role="heading">
                  <span> Launch Your Career with Sparkminds Career Climb Program </span>
                </div>
                <div class="global_sub_title global_banner_subtitle mt-3" aria-level="1" role="heading">
                  <span>Gain real-world experience, build essential skills, and unlock new opportunities. Apply today
                    and start your journey toward professional success!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--======= Banner End Here ========-->
  <div id="formpage" class="formpage" style="background-color: #ffff;margin-top:50px">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-12">
          <div style="color: #000; font-size: 33px; margin-top: 50px; font-weight: 500;">
            The perfect career start is waiting for you.
          </div>
          <div class="application_service-subcontent global_section_content ">
            <p>
              Ready for a program that launches your career to new heights?
            </p>
            <p class="pt-4 181ify-content">
              The <b>SparkMinds Career Climb Program</b> is a hands-on, immersive experience designed to help you grow
              with purpose. You’ll work with emerging technologies, solve real business challenges, and gain insight
              from professionals who know what it takes to succeed—and are ready to help you get there.
            </p>
            <p class="pt-4 181ify-content">
              At SparkMinds, you’ll be trusted to contribute, collaborate, and grow alongside the team from day one. You
              won’t just build skills; you’ll build confidence, clarity, and momentum for your future. If you're ready
              to learn by doing and take the first real step toward a meaningful career, your climb starts here.<b>
                Apply Now ! </b> </p>

          </div>
        </div>
        <div class="col-sm-12 col-lg-6 col-md-12 intern_formcol" id='sectionOne' style="top:30%;">
          <div class="border border-1  p-3 intern_forDiv">
            <div class=" text-center m-1 mt-4 py-2 h1 sbtDiv" style="color:#182357; font-size:23px;" aria-level="1"
              role="heading">
              <b>Submit your Details</b>
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="form-floating internForm" style="height:60px">
                <input type="text" class="form-control my-4" formControlName="Name" aria-required="true" required
                  id="Name" style="height:50px;" placeholder="Name*" minlength="2" maxlength="30">
                <label for="Name" class="internship_label text-secondary">Name*</label>
                <div *ngIf="isFormControlInvalid('Name')" class="formError">{{ getErrorMessage('Name') }}</div>
              </div>

              <div class="form-floating" style="height:60px">
                <input type="text" aria-required="true" required formControlName="Qualification" id="Qualification"
                  class="form-control my-4" autocomplete="off" style="height:50px;" placeholder="Degree/Qualification*"
                  minlength="2" maxlength="30">
                <label for="Qualification" class=" internship_label text-secondary">Degree/Qualification*</label>
                <div *ngIf="isFormControlInvalid('Qualification')" class="formError">{{ getErrorMessage('Qualification')
                  }}</div>
              </div>
              <div class="form-floating " style="height:60px;">
                <input type="email" formControlName="Email" id="Email" aria-required="true" required="true"
                  class="form-control my-4" autocomplete="off" style="height:50px;" placeholder="*Email">
                <label for="Email" class=" internship_label text-secondary">Email*</label>
                <div *ngIf="isFormControlInvalid('Email')" class="formError"> {{ getErrorMessage('Email') }}</div>
              </div>
              <div class="form-floating my-4" style="height: 60px">
                <ngx-intl-tel-input #phoneInput id="Phone" [(phoneNumber)]="phoneNumber"
                  (phoneNumberChange)="onPhoneNumberChange($event)" [separateDialCode]="true"
                  [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [preferredCountries]="['in','us', 'gb', ]"
                  [searchCountryFlag]="true" [searchCountryField]="['iso2']" [selectFirstCountry]="false"
                  [defaultCountry]="'in'">
                </ngx-intl-tel-input>

                <div *ngIf="isFormControlInvalid('Phone')" class="formError"> {{ getErrorMessage('Phone') }}</div>

                <div *ngIf="isInvalid" class="text-danger mt-1 formError">
                  {{ phoneErrorMessage }}
                </div>
              </div>
              <div class="form-floating  " style="height:60px;">
                <select aria-required="true" required formControlName="selectInterstedProgram"
                  id="selectInterstedProgram" class="form-control my-4" style="height: 50px;"
                  placeholder="Select Program">
                  <option value="Sparkminds Orientation" selected="selected">sparkminds orientation</option>
                  <option value="Code Compitation">code competition</option>
                  <option value="Both">both</option>
                </select>
                <label for="selectInterstedProgram">Select Program</label>
                <div *ngIf="isFormControlInvalid('selectInterstedProgram')" class="formError">Please select a program.
                </div>
              </div>
              <div class="form-floating my-4">
                <div class="input-group">
                  <input type="file" id="attachment" aria-required="true" formControlName="attachment"
                    (change)="onFileSelected($event)" class="form-control d-none my-4">
                  <label for="attachment" class="btn btn-primary border-radius " id="fileLabel">upload your
                    profile</label>
                  <span class="file-name" *ngIf="this.selectedFile">
                    {{ profileName }}
                  </span>
                </div>
                <div *ngIf="isFormControlInvalid('attachment')" class="formError my-4">
                  {{ getErrorMessage('attachment') }}
                </div>
              </div>

              <!-- background: transparent linear-gradient(175deg, #9442EA 0%) 0% 0% no-repeat padding-box!important; -->
              <div class="d-grid gap-2" style="height:50px;  margin-top: 39px; margin-left: 10%; width: 80%;">
                <button type="submit" [disabled]="form.invalid || isSubmitting" class="btn btn-lg" id="submitBtn"
                  style="height:50px;" role="button" aria-haspopup="true" tabindex="0">Apply Now</button>
              </div>
              <div *ngIf="loading" class="loader-container">
                <mat-spinner></mat-spinner>
                <div class="loader-wheel"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--======= Form End Here ========-->
  <div class="mt-5" id="For-you">
    <div class="row">
      <div class="global_section_header pb-4">Sparkminds Career Climb Program</div>
      <br><br>
      <div class="col-md-4">
        <div class="boxcontent">
          <div class="col max-mb-30 aos-init aos-animate" data-aos="fade-up">
            <a (click)="scrollToSection('main-wrapper')" class="icon-box text-center" data-bg-color="#fff"
              style="background-color: rgb(255, 255, 255);" data-abc="true" id="boxcontent-height" role="button"
              aria-haspopup="true" tabindex="0">
              <div class="icon"> <img src="../../../assets/images/InternshipPage/Hands-On-Learning.png"
                  class="img-fluids grayscale" alt="Seamless" width="240"> </div>
              <div class="content">
                <h6 class="title_Contents">1. Hands on- experience on real-time projects</h6>
                <div class="desc">
                  <p>Acquire practical skills and real-world knowledge through active participation in projects and
                    day-to-day operations.</p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="boxcontent">
          <div class="col max-mb-30 aos-init aos-animate" data-aos="fade-up"> <a
              (click)="scrollToSection('main-wrapper')" class="icon-box text-center" data-bg-color="#fff"
              style="background-color: rgb(255, 255, 255);" data-abc="true" role="button" aria-haspopup="true"
              tabindex="0" id="boxcontent-height">
              <div class="icon"> <img src="../../../assets/images/InternshipPage/Real-world-Project.png"
                  class="img-fluids grayscale" alt="Personalized Support" width="240"> </div>
              <div class="content">
                <h6 class="title_Contents"> 2. Industry Exposure </h6>
                <div class="desc">
                  <p>Gain insights into the workings of your chosen field, bridging the gap between theoretical learning
                    and actual industry practices.</p>
                </div>
              </div>
            </a> </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="boxcontent">
          <div class="col max-mb-30 aos-init aos-animate" data-aos="fade-up"> <a
              (click)="scrollToSection('main-wrapper')" class="icon-box text-center" data-bg-color="#fff"
              style="background-color: rgb(255, 255, 255);" role="button" aria-haspopup="true" tabindex="0"
              data-abc="true" id="boxcontent-height">
              <div class="icon"> <img src="../../../assets/images/InternshipPage/Mentorship.png"
                  class="img-fluids grayscale" alt="Mentorship" width="240"> </div>
              <div class="content">
                <h6 class="title_Contents">3. Expert Instructors with one-to-one guidance</h6>
                <div class="desc">
                  <p>Acquire industry insights at your own pace from seasoned professionals with extensive expertise.
                  </p>
                </div>
              </div>
            </a> </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="boxcontent">
          <div class="col max-mb-30 aos-init aos-animate" data-aos="fade-up"> <a
              (click)="scrollToSection('main-wrapper')" class="icon-box text-center" data-bg-color="#fff"
              style="background-color: rgb(255, 255, 255);" role="button" aria-haspopup="true" tabindex="0"
              data-abc="true" id="boxcontent-height">
              <div class="icon"> <img src="../../../assets/images/InternshipPage/Comprehensive-Curriculum.png"
                  class="img-fluids grayscale" alt="Comprehensive Curriculum" width="240"> </div>
              <div class="content">
                <h6 class="title_Contents">4. Comprehensive curriculum</h6>
                <div class="desc">
                  <p> Receive extensive training in leading technologies relevant to the job market and real-time
                    business scenarios.</p>
                </div>
              </div>
            </a> </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="boxcontent">
          <div class="col max-mb-30 aos-init aos-animate" data-aos="fade-up"> <a
              (click)="scrollToSection('main-wrapper')" class="icon-box text-center" data-bg-color="#fff"
              style="background-color: rgb(255, 255, 255);" role="button" aria-haspopup="true" tabindex="0"
              data-abc="true" id="boxcontent-height">
              <div class="icon"> <img src="../../../assets/images/InternshipPage/Enhanced-Skillset.png"
                  class="img-fluids grayscale" alt="Enhanced Skillset" width="240"> </div>
              <div class="content">
                <h6 class="title_Contents">5.Enhanced Skillset</h6>
                <div class="desc">
                  <p>Develop a diverse skillset that goes beyond academic knowledge, making you more versatile and
                    competitive in the job market.</p>
                </div>
              </div>
            </a> </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="boxcontent">
          <div class="col max-mb-30 aos-init aos-animate" data-aos="fade-up">
            <a (click)="scrollToSection('main-wrapper')" class="icon-box text-center" data-bg-color="#fff"
              style="background-color: rgb(255, 255, 255);" role="button" aria-haspopup="true" tabindex="0"
              data-abc="true" id="boxcontent-height">
              <div class="icon"> <img src="../../../assets/images/InternshipPage/Certification.png"
                  class="img-fluids grayscale" alt="Certification" width="240"> </div>
              <div class="content">
                <h6 class="title_Contents">6. Internship Certificate</h6>
                <div class="desc">
                  <p>Get a Sparkminds certificate after successful completion of Internship/ Training program.
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--===== Single Blog Item End =========-->
  <!--====== Open Roles  Start ======-->
  <section class="job_area section--padding;" style="padding: 20px;">
    <div class="container">
      <div class="row">
        <div class="col-md-12 py-5">
          <div class="global_section_header ">Open Career Training Opportunities</div>
          <p class="text-center">View our internship and training opportunities to start your course toward a future of
            innovation, growth, and success.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-sm-12">
          <div class="card_style2">
            <div class="save_job">
              <span class="icon-heart" title="" data-bs-toggle="tooltip" data-bs-original-title="Save Job"></span>
            </div>
            <h6 class="card_style2__title">Software Engineering</h6>
            <div class="card_style2__location_type">
              <p>
                <span class="icon-location-pin"></span>6 Openings
              </p>
              <span class="type pcolorbg">Full Time</span>
            </div>
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center">
              <a href="#" aria-label="pro" role="button" tabindex="0" aria-haspopup="true" tabindex="0"
                (click)="scrollToSection('main-wrapper')" class="btn-hover mt-1 mx-auto d-block" data-bs-toggle='modal'
                data-bs-target='#pspa37' id="modal37">
                <p hidden>pro</p>
                <em></em>
              </a>
              <a href="#" aria-label="Learn More" role="button" tabindex="0" aria-haspopup="true"
                class="global_button text-left" data-bs-toggle="modal" data-bs-target="#myModal46">
                <div class="dub-arrow">
                  <img src="../../../assets/images/button/arrowBlack.png" alt="Software details" />
                </div>
                Learn More
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card_style2">
            <div class="save_job">
              <span class="icon-heart" title="" data-bs-toggle="tooltip" data-bs-original-title="Save Job"></span>
            </div>
            <div class="card_style2__title h4 fw-bold">Cloud Services</div>
            <div class="card_style2__location_type">
              <p>
                <span class="icon-location-pin"></span>4 Openings
              </p>
              <span class="type pcolorbg">Full Time</span>
            </div>
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center">
              <a href="#" aria-label="pro" role="button" aria-haspopup="true" tabindex="0"
                class="btn-hover mt-1  mx-auto d-block" data-bs-toggle='modal' data-bs-target='#pspa37' id="modal37">
                <p hidden>pro</p>
                <em></em>
              </a>
              <a href="#" aria-label="Learn More" role="button" aria-haspopup="true" tabindex="0"
                class="global_button   text-left " data-bs-toggle="modal" data-bs-target="#myModal47">
                <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="Cloud details" />
                </div>
                Learn More
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card_style2">
            <div class="save_job">
              <span class="icon-heart" title="" data-bs-toggle="tooltip" data-bs-original-title="Save Job"></span>
            </div>
            <div class="card_style2__title h4 fw-bold"> Full Stack Development </div>
            <div class="card_style2__location_type">
              <p>
                <span class="icon-location-pin"></span>10 Openings
              </p>
              <span class="type pcolorbg">Full Time</span>
            </div>
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center">
              <a href="#" aria-label="pro" class="btn-hover mt-1  mx-auto d-block" data-bs-toggle='modal'
                data-bs-target='#pspa37' id="modal37">
                <p hidden>pro</p>
                <em></em>
              </a>
              <a href="#" aria-label="Learn More" role="button" aria-haspopup="true" tabindex="0"
                class="global_button   text-left " data-bs-toggle="modal" data-bs-target="#myModal48">
                <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                    alt=" Full Stack Development" /></div>
                Learn More
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card_style2">
            <div class="save_job">
              <span class="icon-heart" title="" data-bs-toggle="tooltip" data-bs-original-title="Save Job"></span>
            </div>
            <div class="card_style2__title h4 fw-bold">Testing</div>
            <div class="card_style2__location_type">
              <p>
                <span class="icon-location-pin"></span>2 Openings
              </p>
              <span class="type pcolorbg">Full-time</span>
            </div>
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center">
              <a href="#" aria-label="pro" class="btn-hover mt-1 mx-auto d-block" data-bs-toggle='modal'
                data-bs-target='#pspa37' id="modal37">
                <p hidden>pro</p>
                <em></em>
              </a>
              <a href="#" aria-label="Learn More" role="button" aria-haspopup="true" tabindex="0"
                class="global_button   text-left" data-bs-toggle="modal" data-bs-target="#myModal49">
                <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="Testing" /></div>
                Learn More
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card_style2">
            <div class="save_job">
              <span class="icon-heart" title="" data-bs-toggle="tooltip" data-bs-original-title="Save Job"></span>
            </div>
            <div class="card_style2__title h4 fw-bold">Machine Learning</div>
            <div class="card_style2__location_type">
              <p>
                <span class="icon-location-pin"></span>4 Openings
              </p>
              <span class="type pcolorbg">Full-time</span>
            </div>
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center">
              <a href="#" aria-label="pro" class="btn-hover mt-1  mx-auto d-block" data-bs-toggle='modal'
                data-bs-target='#pspa37' id="modal37">
                <p hidden>pro</p>
                <em></em>
              </a>
              <a href="#" aria-label="Learn More" role="button" aria-haspopup="true" tabindex="0"
                class="global_button text-left" data-bs-toggle="modal" data-bs-target="#myModal50">
                <div class="dub-arrow">
                  <img src="../../../assets/images/button/arrowBlack.png" alt="Machine Learning" />
                </div>
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--====== Open Roles End ======-->
  <div class="container">
    <div class="row">
      <div class="col-md-12" style="margin-top: 5%;">
        <div class="global_section_header">Get trained in comprehensive technology</div>
        <p style="text-align: center; padding: 30px">Sparkminds is dedicated to offering training that spans a wide
          range of areas, guaranteeing you acquire a comprehensive, multi-disciplinary skill set.</p>
      </div>
    </div>
    <div class="Testimonials text-center">
      <div class="container mt-5" id="testimonials-logos">
        <div class="row" id="testimonials-logos">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="0" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/Angular.png" class="img-fluid grayscale" alt="Angular">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="1" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/react.jpg" class="img-fluid grayscale" alt="React">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="2" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/cypress.jpg" class="img-fluid grayscale" alt="cypress">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="0" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/Didital-Marketing.jpg" class="img-fluid grayscale"
                alt="Digital Marketing">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="1" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/dot_net.png" class="img-fluid grayscale" alt="dot net">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="2" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/java-full-stack-1.jpg" class="img-fluid grayscale"
                alt="java full stack">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="0" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/manual-api-testing-with-postman.jpg"
                class="img-fluid grayscale" alt="manual api testing with postman">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="1" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/manual-testing.jpg" class="img-fluid grayscale"
                alt="manual testing">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="2" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/MEAN-STACK.jpg" class="img-fluid grayscale"
                alt="mean stack">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="0" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/Microsoft-SQL-Azure.jpg" class="img-fluid grayscale"
                alt="Microsoft SQL Azure">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="1" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/MSBI.jpg" class="img-fluid grayscale" alt="MSBI">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="2" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/python.jpg" class="img-fluid grayscale" alt="python">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="0" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/Sql-server.jpg" class="img-fluid grayscale"
                alt="Sql server">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="1" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/Testing-tools.jpg" class="img-fluid grayscale"
                alt="Testing tools">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="2" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/AI/Ml.png" class="img-fluid grayscale" alt="AI Ml">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 logo-container">
            <div class="logo" data-slide-to="1" data-bs-target="#testimonial-carousel">
              <img src="../../../assets/images/InternshipPage/web-desion.jpg" class="img-fluid grayscale"
                alt="web design">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Mobile End-to end Mobile application services -->
  <div class="gradation-process-area section-space--ptb_100 mt-5">
    <div class="row">
      <div class="col-lg-1 col-sm-12"></div>
      <div class="col-lg-10 col-sm-12">
        <div class="gradation-title-wrapper section-space--mb_60">
          <div class="gradation-title-wrap  ">
            <div class="global_section_header" style="text-align: left;"> Application Process</div>
            <p class="global_section_content">Ready to apply? Here’s a summary on what you can generally expect during
              your application.</p>
          </div>
          <div class="gradation-sub-heading">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-1 col-sm-12"></div>
      <div class="col-lg-10 col-sm-12">
        <div class="ht-gradation style-01">
          <!-- Single item gradation Start -->
          <div class="item item-1 animate  wow fadeInRight" data-aos="fade-left" data-aos-duration="1500">
            <div class="line"></div>
            <div class="circle-wrap">
              <div class="mask">
                <div class="wave-pulse wave-pulse-1"></div>
                <div class="wave-pulse wave-pulse-2"></div>
                <div class="wave-pulse wave-pulse-3"></div>
              </div>

              <p class="circle"><i class="fa fa-file-text-o"></i></p>
            </div>

            <div class="content-wrap" role="main">
              <a (click)="scrollToSection('main-wrapper')" role="button" aria-haspopup="true" tabindex="0">
                <div class="heading text-dark h2 fw-bold">Resume</div>
              </a>
              <div class="global_section_content text_resume h2">Submit your resume via our website and our team will
                contact you</div>

            </div>
          </div>
          <!-- Single item gradation End -->
          <!-- Single item gradation Start -->
          <div class="item item-1 animate  wow fadeInRight" data-aos="fade-left" data-aos-duration="1500">
            <div class="line"></div>
            <div class="circle-wrap">
              <div class="mask">
                <div class="wave-pulse wave-pulse-1"></div>
                <div class="wave-pulse wave-pulse-2"></div>
                <div class="wave-pulse wave-pulse-3"></div>
              </div>

              <p class="circle"><i class="fa fa-search"></i></p>
            </div>
            <div class="content-wrap">
              <a (click)="scrollToSection('main-wrapper')" role="button" aria-haspopup="true" tabindex="0">
                <div class="heading text-dark h2 fw-bold">Exploratory chat & Skills Assessment</div>
              </a>
              <div class="text global_section_content">Discuss your career options & get a skills assessment
              </div>

            </div>
          </div>
          <!-- Single item gradation End -->
          <!-- Single item gradation Start -->
          <div class="item item-1 animate  wow fadeInRight" data-aos="fade-left" data-aos-duration="1500">
            <div class="line"></div>
            <div class="circle-wrap">
              <div class="mask">
                <div class="wave-pulse wave-pulse-1"></div>
                <div class="wave-pulse wave-pulse-2"></div>
                <div class="wave-pulse wave-pulse-3"></div>
              </div>
              <div class="circle"> <i class="fa fa-users"></i></div>
            </div>
            <div class="content-wrap">
              <a (click)="scrollToSection('main-wrapper')" role="button" aria-haspopup="true" tabindex="0">
                <div class="heading text-dark h4 fw-bold">Team Screen & Interview Panel</div>
              </a>
              <div class="global_section_content team_text">Conversation with Hiring Manager or potential team member.
              </div>

            </div>
          </div>
          <!-- Single item gradation End -->
          <!-- Single item gradation Start -->
          <div class="item item-1 animate wow fadeInRight" data-aos="fade-left" data-aos-duration="1500">
            <div class="line"></div>
            <div class="circle-wrap">
              <div class="mask">
                <div class="wave-pulse wave-pulse-1"></div>
                <div class="wave-pulse wave-pulse-2"></div>
                <div class="wave-pulse wave-pulse-3"></div>
              </div>
              <p class="circle"><i class="fa fa-check"></i></p>
            </div>
            <div class="content-wrap">
              <a (click)="scrollToSection('main-wrapper')" role="button" aria-haspopup="true" tabindex="0">
                <div class="heading text-dark h2 fw-bold">Final Checks</div>
              </a>
              <div class=" global_section_content Final_text">We’ll ask for some references, & have you chat with our
                leadership.</div>

            </div>
          </div>
          <!-- Single item gradation End -->
          <!-- Single item gradation Start -->
          <div class="item item-1 animate  wow fadeInRight" data-aos="fade-left" data-aos-duration="1500">
            <div class="line"></div>
            <div class="circle-wrap">
              <div class="mask">
                <div class="wave-pulse wave-pulse-1"></div>
                <div class="wave-pulse wave-pulse-2"></div>
                <div class="wave-pulse wave-pulse-3"></div>
              </div>
              <div class="circle"> <i class="fa fa-handshake-o"></i></div>
            </div>
            <div class="content-wrap">
              <a (click)="scrollToSection('main-wrapper')" role="button" aria-haspopup="true" tabindex="0">
                <div class="heading text-dark h2 fw-bold">Offer</div>
              </a>
              <div class=" global_section_content offer_text">Join our team!
              </div>
            </div>
          </div>
          <!-- Single item gradation End -->
        </div>
      </div>
    </div>
  </div>
  <!--====== Carousels Start Here ======-->
  <section class="employee-carosels">
    <div class="testimonial-slider-area pt-5">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="Training-areas ">
              <div class="global_section_header"> The Inside Scoop: Employee Testimonials </div>
              <p style="text-align: center; padding: 30px">Uncover the inside scoop on working with us from those who
                know best—our employees.</p>
            </div>
            <div class="testimonial-slider">
              <swiper-container #swiperContainer class="testimonial-slider__container" slides-per-view="2"
                [autoplay]="{ delay: 3000 }" [pagination]="{ el: '.swiper-pagination', clickable: true }" [loop]="true"
                [breakpoints]="swiperBreakpoints">
                <swiper-slide class=" employee-slider  ">
                  <div class=" recognition-employees testimonial-slider__one wow move-up">
                    <div class="testimonial-slider--info">
                      <div class="testimonial-slider__media pt-3">
                        <img src="../../../assets/images/recognition/placeholder.png" class="img-fluid"
                          alt="Employee Testimonial">
                      </div>
                      <div class="testimonial-slider__author" style="padding: 30px 20px;">
                        <div class="author-info">
                          <h6 class="name">Meghanath , Proud Alumnus.</h6>
                        </div>
                      </div>
                    </div>
                    <div class="global_section_content recognition-slider testimonial-slider__text">
                      "Maganti IT has been a transformative journey for my career. Their comprehensive training programs
                      equipped me with cutting-edge skills and industry insights, enabling me to excel in the
                      competitive IT landscape.
                      The personalized mentorship and hands-on experience I received during my Training were
                      invaluable. Thanks to Maganti IT, I am now confidently shaping my path in the tech world."
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide class=" employee-slider  ">
                  <div class="recognition-employees   testimonial-slider__one wow move-up">
                    <div class="testimonial-slider--info">
                      <div class="testimonial-slider__media pt-3">
                        <img src="../../../assets/images/recognition/placeholder.png" class="img-fluid"
                          alt="Employee Testimonial ">
                      </div>
                      <div class="testimonial-slider__author" style="padding: 30px 20px;">
                        <div class="author-info">
                          <h6 class="name">Swati Reddy, Application developer</h6>
                        </div>
                      </div>
                    </div>
                    <div class="global_section_content recognition-slider testimonial-slider__text">
                      "Choosing Maganti IT for my career training was an excellent decision. Their training programs are
                      top-notch, providing in-depth knowledge and
                      practical skills that are directly applicable to real-world scenarios. The experienced instructors
                      and interactive learning approach made the learning journey enjoyable and effective.
                      Thanks to Maganti IT, I am now well-prepared and confident to tackle the challenges of my IT
                      career."</div>
                  </div>
                </swiper-slide>
                <swiper-slide class=" employee-slider  ">
                  <div class=" recognition-employees testimonial-slider__one wow move-up">
                    <div class="testimonial-slider--info">
                      <div class="testimonial-slider__media pt-3">
                        <img src="../../../assets/images/recognition/placeholder.png" class="img-fluid"
                          alt="Employee Testimonial">
                      </div>
                      <div class="testimonial-slider__author" style="padding: 30px 20px;">
                        <div class="author-info">
                          <h6 class="name">S. Kavya, Data Scientist Intern </h6>
                        </div>
                      </div>
                    </div>
                    <div class="global_section_content recognition-slider testimonial-slider__text">
                      "The guidance and support I received from my mentors were instrumental in my career growth. Their
                      insights, advice,
                      and personalized attention helped me navigate the complexities of the IT industry with confidence.
                      Thanks to Maganti IT, I not only gained technical skills but also had the privilege of learning
                      from the best mentors in the field."</div>
                  </div>
                </swiper-slide>
                <swiper-slide class=" employee-slider  ">
                  <div class="  recognition-employees testimonial-slider__one wow move-up">
                    <div class="testimonial-slider--info">
                      <div class="testimonial-slider__media pt-3">
                        <img src="../../../assets/images/recognition/placeholder.png" class="img-fluid"
                          alt="Employee Testimonial">
                      </div>
                      <div class="testimonial-slider__author" style="padding: 30px 20px;">
                        <div class="author-info">
                          <h6 class="name">Ramesh Chandra, Full Stack Developer</h6>
                        </div>
                      </div>
                    </div>
                    <div class="global_section_content recognition-slider testimonial-slider__text">
                      "It has been a transformative experience for me, especially after a career gap. Their program
                      catered perfectly to my needs,
                      helping me bridge the gap and regain my professional confidence. The supportive mentors and
                      relevant training empowered me to reenter the workforce with updated skills.
                      Thanks to Maganti IT, I successfully transitioned back into my career and am now thriving in the
                      IT industry once again".</div>
                  </div>
                </swiper-slide>
              </swiper-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--====== Carousels End Here ======-->
  <!--====== Join Our Team Section Start Here ======-->
  <section class=" internship-bottom h-100vh">
    <div class="w-100" id="intern_bottom">
      <img src="../../../assets/images/intern/intern-bottom.png" width="100%" class="internship_cultureimage"
        alt="intership team" />
      <div class="intern_bootom_box">
        <div class="intern_bottom_box_header text-center mt-3" style="font-family: 'Comfortaa'; font-size:35px;">Join
          Our Team</div>
        <div class="intern_bottom_box_text text-center global_section_content">We're a close-knit team of enthusiastic
          tech-innovators, strategists, and creative thinkers. Think you'll fit in just fine?</div>
        <div class="text-center col pt-lg-4 pt-5 mt-lg-5">
          <a href="contact" class="global_button  text-left col pt-5 text-white white_button"
            aria-label="View Contact Page">
            <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="Explore jobs" /></div>
            EXPLORE JOBS
          </a>
        </div>
      </div>
    </div>
  </section>
  <!--------------Footer first-Section Starts-->
  <div class="footer-area-wrapper">
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-lg-12 p-0">
          <div class="footer-titles p-5">
            <div class="p-2 global_section_headers thirdheading text-white text-center">
              Build confidence, skills, and a career you love. Start now with SparkMinds Career Climb program.
            </div>
            <div class="global_mainbutton text-center col pt-5 d-flex justify-content-center">
              <a (click)="scrollToSection('formpage')" onclick="scrollToFormPage()" role="button" aria-haspopup="true"
                tabindex="0" class="global_buttons text-white white_button">
                <div class="dub-arrow">
                  <img src="../../../assets/images/button/arrowWhite.png" alt="arrowWhite.png" ria-hidden="true" />
                </div>
                Register Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--------------Footer first-Section ends-->
  <div class="modal" id="myModal46">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="career-modal global_sub_title mx-5 ">Software Engineering</div>
        </div>
        <div class="modal-body">
          <div class='page-meta career_popupcontent'>
          </div>
          <div class="career_popupcontent">Begin your first career and grow to higher roles such as Software Development
            Engineer (In Test), Project/ Technical Lead, Project/Technical Manager, Technical Architect, and more either
            at a module, subsystem, system, application, solution/product or project level.</div>
          <!-- <div class="global_sub_title job-description mt-4"><b>Job duties</b></div> -->
          <div class="career_popupcontent">
            <div class="Contents">
              <div class="global_section_content ouropinion_subcontent mt-3 p-0">
                <b>Eligibility:</b>
                <p class="career_popupcontent">Bachelor’s Degree in Computer Science, Information Technology, Information Systems,
                Electrical, Electronics, Mechanical Engineering or other Stream Majors like Math & Science.</p>
              </div><br>
              <b>What you’ll learn:</b>
              <ul style="list-style-type:disc; line-height: 30px; color: black;">
                <li> Manage individual project priorities, deadlines and deliverables.</li>
                <li>Write design documents and participate in design reviews.</li>
                <li>Setup environment and participate in testing/ trouble shooting existing software issues and
                  implement as per the change management process and bug fixes.</li>
                <li>Optimize developed systems for performance and reliability.</li>
                <li>Operating System provisioning and Storage configuration</li>
                <li>Develop functions, scripts, stored procedures and triggers to support application development.</li>
                <li>Use applicable methodologies, modeling/ estimating techniques, tools, applications, systems,
                  software and/or databases to perform assigned tasks. </li>
              </ul>
            </div>
          </div>
          <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
          <div class="career_popupcontent">Bachelor of Science or related field required. </div>

          <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
          <div class="career_popupcontent">hr&#64;mitresource.com</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="modal_button  btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" id="myModal47">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="career-modal global_sub_title mx-5 ">Cloud Services</div>
        </div>
        <div class="modal-body">
          <div class='page-meta career_popupcontent'>
            Start your journey in Cloud Computing with real-world training and hands-on experience. Begin as a Cloud
            Administrator and build your path toward becoming a Cloud Architect—or expand your expertise across
            cutting-edge technologies as your career grows.
          </div>
          <div class="career_popupcontent">
            <div class="Contents">
             
              <div class="global_section_content ouropinion_subcontent mt-3 p-0">
                <b>Eligibility:</b> 
                <p class="career_popupcontent">
                Bachelor’s Degree in Computer Science, Information Technology, Information Systems,
                Electrical, Electronics, Mechanical Engineering or other STEM Majors like Math & Science.
                </p>
                <p class="career_popupcontent">As a Cloud Administrator Intern, you would learn and perform the following responsibilities:</p>
              </div><br>
              <b>What you’ll learn:</b>
              <ul style="list-style-type:disc; line-height: 30px; color: black;">

                <li>Gain hands-on experience setting up and managing scalable, secure, and efficient cloud
                  infrastructure. Learn resource allocation for optimized utilization and cost-effectiveness.</li>
                <li>Acquire skills in implementing robust security measures to safeguard cloud-based systems and data.
                  Understand monitoring techniques to identify bottlenecks and enhance overall system efficiency.</li>
                <li>Master the essentials of designing and implementing backup and recovery strategies for cloud-based
                  data and applications. Explore collaborative tools for effective communication in a cloud-based
                  environment.</li>
                <li>Develop problem-solving skills to address issues related to cloud infrastructure, ensuring seamless
                  operations. Cultivate a habit of thorough documentation for configurations, processes, and
                  troubleshooting steps.</li>
                <li>Interact cross-functionally and conduct end-to-end analysis, from processing data to presenting
                  results, in collaboration with various teams. Utilize analytical methods on large, complex datasets
                  for open-ended problem-solving.</li>
                <li>Collaborate closely with engineers to identify opportunities for and assess improvements to
                  organizational products.</li>
              </ul>
            </div>
          </div>
          <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
          <div class="career_popupcontent">Bachelor of Science or related field required. </div>

          <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
          <div class="career_popupcontent">hr&#64;mitresource.com</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="modal_button  btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" id="myModal48">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="career-modal global_sub_title mx-5 ">FullStack Development</div>
        </div>
        <div class="modal-body">
          <div class='page-meta career_popupcontent'>
            Bachelor’s Degree in Data Science, Math, Statistics, Computer Science, Information Systems or
            Information Technology.
            Begin as a Cloud Administrator to steadily advance your career, vertically to Cloud Architect, or
            explore opportunities to grow to other technologies.
          </div>
          <div class="career_popupcontent">
            <div class="Contents">
             
              <div class="global_section_content ouropinion_subcontent mt-3 p-0">
                <b>Eligibility:</b> 
                <p class="career_popupcontent">Bachelor’s Degree in Computer Science, Information Technology, Information Systems,
                Electrical, Electronics, Mechanical Engineering or other STEM Majors like Math & Science.</p> 
              </div>
              <b>What you’ll learn:</b>
              <ul style="list-style-type:disc; line-height: 30px; color: black;">

                <li>Participate in the complete software development lifecycle, from concept and design to testing and
                  deployment. </li>
                <li>Learn and apply skills in building responsive and user-friendly interfaces using modern web
                  technologies such as HTML, CSS, and JavaScript. </li>
                <li>Gain proficiency in server-side scripting, database management, and server deployment to ensure
                  seamless functionality and performance. </li>
                <li>Acquire skills in designing and managing databases to ensure efficient storage and retrieval of
                  data.</li>
                <li>Learn to create and integrate APIs, facilitating communication between different parts of a web
                  application.</li>
                <li>Understand and utilize version control systems like Git for efficient collaboration and code
                  management. </li>
                <li>Develop skills in testing code for functionality, identifying and resolving bugs to ensure the
                  reliability of applications.</li>
                <li>Work collaboratively within a team, participating in code reviews and contributing to the overall
                  success of the development projects.</li>
                <li>Learn and implement coding standards, best practices, and industry trends to ensure high-quality and
                  maintainable code.</li>
                <li>Stay updated on emerging technologies and trends in full-stack development, fostering a culture of
                  continuous learning and improvement.</li>
              </ul>
            </div>
          </div>
          <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
          <div class="career_popupcontent">Bachelor of Science or related field required. </div>
          <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
          <div class="career_popupcontent">hr&#64;mitresource.com</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="modal_button  btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" id="myModal49">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="career-modal global_sub_title mx-5 ">Testing</div>
        </div>
        <div class="modal-body">
          <div class='page-meta career_popupcontent'>
            Step into the world of software testing with practical, real-world learning designed to build your technical
            foundation and sharpen your problem-solving skills. You’ll gain hands-on experience across key areas of
            quality assurance, preparing you to grow confidently in today’s fast-moving technology landscape.
          </div>
          <div class="career_popupcontent">
            <div class="Contents">
              <div class="global_section_content ouropinion_subcontent mt-3 p-0">
                <b>Eligibility:</b>
                <p class="career_popupcontent">Bachelor’s Degree in Computer Science, Information Technology,
                  Information Systems, Electrical, Electronics, Mechanical Engineering, or related majors in Math &
                  Science.</p>
                <b>Program Overview:</b>
                <p class="career_popupcontent">Through this program, you will acquire valuable skills and applied
                  knowledge in the field of software testing, including critical areas such as test planning, execution,
                  automation, defect tracking, and quality assurance best practices.</p>
              </div> <br>
            </div>
          </div>
          <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
          <div class="career_popupcontent">Bachelor of Science or related field required. </div>
          <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
          <div class="career_popupcontent">hr&#64;mitresource.com</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="modal_button  btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" id="myModal50">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="career-modal global_sub_title mx-5 ">AI/ML</div>
        </div>
        <div class="modal-body">
          <div class='page-meta career_popupcontent'>
            Artificial Intelligence and Machine Learning are transforming every industry, and skilled professionals are
            in high demand. This program is designed to equip you with hands-on knowledge, critical thinking skills, and
            practical experience needed to succeed in the fast-evolving AI/ML landscape. You’ll work on real-world
            problems, apply core concepts, and build a strong foundation for a future-driven career.

          </div>
          <div class="career_popupcontent">
            <div class="Contents">
              <div class="global_section_content ouropinion_subcontent mt-3 p-0">
                <b>Eligibility:</b>
                <p class="career_popupcontent">Bachelor’s Degree in Computer Science, Information Technology,
                  Information Systems, Data Science, Electrical Engineering, Electronics Engineering, or related majors
                  such as Mathematics, Statistics, and Physics.</p>
                <b>Program Overview:</b>
                <p class="career_popupcontent">This program offers a deep dive into the fundamentals and applications of
                  AI and Machine Learning. You will gain practical skills across areas including supervised and
                  unsupervised learning, neural networks, deep learning, natural language processing (NLP), computer
                  vision, and model evaluation techniques. Throughout the program, you'll work on real-world datasets,
                  build machine learning models, and develop a strong portfolio to showcase your applied knowledge and
                  capabilities.</p>

              </div>
            </div>
            <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
            <div class="career_popupcontent">Bachelor of Science or related field required. </div>
            <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
            <div class="career_popupcontent">hr&#64;mitresource.com</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="modal_button  btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>